export default __webpack_public_path__ + "static/media/Red.a105748e.mp3";